/* Create action types */
import createActionTypes from '../createActionTypes';

export const IS_LOADING = createActionTypes('IS_LOADING');
